(ns common.transaction-process.templates.capman.nest
  (:require
   [common.schema.entities.transaction-process :as tp-schema]
   [common.transaction-process.templates.authoring :as a]
   [common.transaction-process.templates.capman.common :as common]))

(def template-id :transaction-process-template/capman-nest)

(def ^:private strategy-fields
  "Nest strategy fields after the 2026-05-21 testing pass:
   - PIK / Cash interest are percentages (cash is free-text so users can type
     '4 + EURIBOR 3m').
   - Payment term is re-labelled 'Interest payments'.
   - Waiver fee currency field is replaced with a free-text equity participation
     notes field shown only when equity participation = true."
  [:transaction-process/pik-interest-rate
   :transaction-process/cash-interest-rate-text
   :transaction-process/maturity
   :transaction-process/payment-term
   :transaction-process/equity-participation?
   :transaction-process/equity-participation-type
   :transaction-process/equity-participation-notes])

(def ^:private investment-amount-fields
  "Nest-specific investment-amount fields. The Loan / Principal amount leads the
   shared Investment amounts breakdown (it is a CapMan maximum-component, so it
   feeds the computed Maximum/Total)."
  [:transaction-process/loan-principal-amount])

(def ^:private investment-amount-field-configs
  "CapMan feedback: in a Nest fund the fund invests purely by lending, so 'Equity'
   doesn't work as the headline amount. Loan / Principal takes over Equity's
   required role (mandatory for initial-investment/follow-on, mirroring the shared
   Equity rule); Equity stays available but optional (a Nest deal may still carry
   an equity component). This override wins over the shared base via the
   strategy-field-configs merge in build-template."
  {:transaction-process/loan-principal-amount
   (merge {:field/visibility :visibility/always}
          (a/mandatory-when-tx-type [:initial-investment :follow-on]))

   :transaction-process/equity-amount
   {:field/visibility    :visibility/always
    :field/mandatoriness :mandatory/optional}})

(def ^:private strategy-field-configs
  {:transaction-process/pik-interest-rate
   {:field/label         "PIK interest (%)"
    :field/visibility    :visibility/always
    :field/mandatoriness :mandatory/optional}

   :transaction-process/cash-interest-rate-text
   {:field/label         "Cash interest"
    :field/placeholder   "e.g. 4 + EURIBOR 3m"
    :field/visibility    :visibility/always
    :field/mandatoriness :mandatory/optional}

   :transaction-process/maturity
   {:field/visibility    :visibility/always
    :field/mandatoriness :mandatory/optional}

   :transaction-process/payment-term
   {:field/label         "Interest payments"
    :field/visibility    :visibility/always
    :field/mandatoriness :mandatory/optional
    :field/options       (mapv (fn [{:keys [key label]}] {:value key :label label})
                               tp-schema/payment-term-options)}

   :transaction-process/equity-participation?
   {:field/visibility    :visibility/always
    :field/mandatoriness :mandatory/optional
    :field/full-width    true}

   :transaction-process/equity-participation-type
   (merge (a/field-visible-when :transaction-process/equity-participation?)
          {:field/mandatoriness :mandatory/optional
           :field/options       [{:value :equity-participation.type/direct          :label "Direct"}
                                 {:value :equity-participation.type/convertible      :label "Convertible"}
                                 {:value :equity-participation.type/preferred-return :label "Preferred return"}
                                 {:value :equity-participation.type/participating    :label "Participating"}
                                 {:value :equity-participation.type/warrant          :label "Warrant"}
                                 {:value :equity-participation.type/option           :label "Option"}]})

   :transaction-process/equity-participation-notes
   (merge (a/field-visible-when :transaction-process/equity-participation?)
          {:field/mandatoriness :mandatory/optional
           :field/full-width    true})})

(def template
  (common/build-template
   {:template-id                    template-id
    :template-name                  "Nest"
    :strategy-fields                strategy-fields
    :strategy-field-configs         (merge strategy-field-configs
                                           investment-amount-field-configs)
    :strategy-card-label            "Debt / Nest fields"
    :strategy-card-subtitle         "Fields specific to the Nest strategy"
    :extra-investment-amount-fields investment-amount-fields}))
